<template>
    <div :key="iteration">
        <loading v-show="isLoading"></loading>

        <text-extended
            :classes="classes"
            :title="title"
            :sections="sections"
            :heading="title.heading"
        />
    </div>
</template>

<script>
    import ApiWidget from './ApiWidget';

    export default ApiWidget.extend({
        props: [
            'response'
        ],

        data() {
            return {
                title: {},
                sections: [],
                classes: 'text-widget',
            }
        },

        created() {
            this.registerParameterListeners([
                'investor',
                'portfolio',
                'range',
                'riskRated',
                'scheme',
                'searchString',
                'startDate',
                'endDate',
            ]);
        },

        methods: {
            async update(data) {
                this.title = this.retrieveTitle(data);
                this.sections = this.retrieveSections(data);
            }
        }
    });
</script>
